'use client';

import React, { createContext, useContext, useState } from 'react';

const EstimatorContext = createContext();

export const useEstimator = () => useContext(EstimatorContext);

const initialFormData = {
  estimateId: null,
  projectInfo: {
    date: '',
    estimatedBy: '',
    requestedBy: '',
    projectName: '',
    projectScope: '',
    estimateClass: '',
  },
  quantities: [],
  rowCalculator: [],
  pipeSpecs: [],
  costAssumptions: [],
  specialItems: [],
  costCategory: [],

  overrideCost: '',
  averageROWCostPerFoot: null,
  averageROWCostPerRod: null,
  totalPercentOfRoute: null,

  hiddenPipeCostCalc: {},
  hiddenNDECalc: {},
};

// NEW: Initial structure for section totals
const initialSectionSummaries = {
  14: null,
  29: null,
  51: null,
  55: null,
};

export const EstimatorProvider = ({ children }) => {
  const [formData, setFormData] = useState(initialFormData);
  const [sectionSummaries, setSectionSummaries] = useState(initialSectionSummaries);
  const [budgetSummaryRows, setBudgetSummaryRows] = useState([]);
  const [metricsSummaryRows, setMetricsSummaryRows] = useState([]);
  const [assumptionsSummarytRows, setAssumptionsSummaryRows] = useState([]);
  const [quantitiesSummaryRows, setQuantitiesSummaryRows] = useState([]);

  const clearFormData = () => {
    setFormData(initialFormData);
    setSectionSummaries(initialSectionSummaries);
  };

  return (
    <EstimatorContext.Provider
      value={{
        formData,
        setFormData,
        clearFormData,
        sectionSummaries,
        setSectionSummaries, // expose updater for all components
        budgetSummaryRows, // NEW
        setBudgetSummaryRows, // NEW
        metricsSummaryRows,
        setMetricsSummaryRows,
        assumptionsSummarytRows,
        setAssumptionsSummaryRows,
        quantitiesSummaryRows,
        setQuantitiesSummaryRows,
      }}
    >
      {children}
    </EstimatorContext.Provider>
  );
};
